import { type RefObject, useCallback, useRef } from 'react';

import type { Transition } from '@atlaskit/motion/entering/types';

import { type ModalDialogProps } from '../../types';

/**
 * This will run the respective passed in callback functions when modal is
 * opened or closed.
 */
export default function useOnMotionFinish({
	onOpenComplete,
	onCloseComplete,
}: Pick<ModalDialogProps, 'onOpenComplete' | 'onCloseComplete'>): [
	RefObject<HTMLElement>,
	(state: Transition) => void,
] {
	const motionRef = useRef<HTMLElement>(null);
	const onMotionFinish = useCallback(
		(state: Transition) => {
			if (state === 'entering' && onOpenComplete) {
				onOpenComplete(motionRef.current!, true);
			}

			if (state === 'exiting' && onCloseComplete) {
				onCloseComplete(motionRef.current!);
			}
		},
		[onOpenComplete, onCloseComplete],
	);

	return [motionRef, onMotionFinish];
}
